// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".str-chat {\n  height: 100%;\n}\n\n.str-chat__loading-channels {\n  width: 100%;\n}\n\n.str-chat-channel.messaging .str-chat__main-panel {\n  padding: 0;\n}\n\n.messaging.str-chat .str-chat__thread {\n  position: relative;\n}\n", ""]);
// Exports
module.exports = exports;
